import React from "react";
import Icon from "../../_default/Icon";
import "./Chat.scss";
import FeatherIcon from "feather-icons-react";

function RenderChatContent(props) {
  return (
    <div
      className={"from-me-content --" + (props.withMesssage ? "message" : props.type)}
      style={
        props.read
          ? {
              marginBottom: 0,
            }
          : {}
      }
    >
      <div className={`c-chat-progress-wrapper ${props.length >= 2 && "--two"}`}>
        {props.content.map((item, idx) => (
          <div key={idx}>
            {item && item.type === "application/pdf" ? (
              <div className="c-uploaded-files">
                <p className="c-file-name">{item.name}</p>
                <div className="c-uploaded-file-type">
                  <Icon icon="pdf" stroke="#fff" size={20} height={20} />
                  <span>PDF file</span>
                  <a href={item.url} target="_blank" download className="c-uploaded-file-download">
                    <FeatherIcon icon="download" size="15" />
                  </a>
                </div>
              </div>
            ) : item && item.type === "application/zip" ? (
              <div className="c-uploaded-files">
                <p className="c-file-name">{item.name}</p>
                <div className="c-uploaded-file-type">
                  <Icon icon="zip" stroke="#fff" size={20} height={20} />
                  <span>ZIP file</span>
                  <a href={item.url} className="c-uploaded-file-download">
                    <FeatherIcon icon="download" size="15" />
                  </a>
                </div>
              </div>
            ) : item && (item.type?.split("/")[0] === "video" || item.type === "video") ? (
              <div className="c-uploaded-files">
              <p className="c-file-name">{item.name}</p>
              <div className="c-uploaded-file-type">
                <Icon icon="video"stroke="#000" size={20} height={20} />
                <span>MP4 video</span>
                <a href={item.url} target="_blank" className="c-uploaded-file-download">
                  <FeatherIcon icon="download" size="15" />
                </a>
              </div>
            </div>
            ) : (
              <div
                className="c-upload-content"
                style={{
                  backgroundImage: `url("${item ? item.url : ""}")`,
                }}
              >
                <a href={item.url} target="_blank" download className="c-uploaded-file-download">
                  <FeatherIcon icon="download" size="15" />
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function FromMe({ message, type, idx, read }) {
  return (
    <>
      {message.content ? (
        message.message.trim().length > 0 ? (
          <>
            <RenderChatContent withMesssage={true} key={idx} length={message.content.length} content={message.content} type={type} read={read}></RenderChatContent>
            <div className={"from-me --" + type} style={read ? { marginBottom: 0 } : {}}>
              <p>{message.message}</p>
            </div>
          </>
        ) : (
          <RenderChatContent key={idx} length={message.content.length} content={message.content} type={type} read={read}></RenderChatContent>
        )
      ) : (
        <>
          <div className={"from-me --" + type} style={read ? { marginBottom: 0 } : {}}>
            <p>{message.message}</p>
          </div>
        </>
      )}

      {read && <p className="c-chat-read">Read</p>}
    </>
  );
}
